import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

export class Timer extends Component {

	constructor() {
		super();
		this.state = { time: {}, seconds: 840 };
		this.timer = 0;
		this.startTimer = this.startTimer.bind(this);
		this.countDown = this.countDown.bind(this);
	}

	secondsToTime(secs){
		let hours = Math.floor(secs / (60 * 60));
	
		let divisor_for_minutes = secs % (60 * 60);
		let minutes = Math.floor(divisor_for_minutes / 60);
	
		let divisor_for_seconds = divisor_for_minutes % 60;
		let seconds = Math.ceil(divisor_for_seconds);
	    
		if (minutes < 10){
            minutes = "0" + minutes
		}
		if (seconds < 10){
            seconds = "0" + seconds
		}
		
		let obj = {
		  "h": hours,
		  "m": minutes,
		  "s": seconds
		};
		return obj;
	  }

	componentDidMount() {
		let timeLeftVar = this.secondsToTime(this.state.seconds);
		this.setState({ time: timeLeftVar });
		this.startTimer();
	}

	startTimer() {
		if (this.timer == 0 && this.state.seconds > 0) {
		  this.timer = setInterval(this.countDown, 1000);
		}
	}
	
	countDown() {
		// Remove one second, set state so a re-render happens.
		let seconds = this.state.seconds - 1;
		this.setState({
			time: this.secondsToTime(seconds),
			seconds: seconds,
		});
		
		// Check if we're at zero.
		if (seconds == 0) { 
			clearInterval(this.timer);
		}
	}
    
	render() {
        return (
            <div className="timer bg-white p-md-5 p-3 position-absolute">
			    <div className="row align-items-center justify-content-center">
				    <div className="col-auto d-flex align-items-center justify-content-md-start justify-content-center position-relative">
					    <i className="d-md-block d-none far fa-clock mr-3"></i>
						<div className="text-md-left text-center">
						    <h3 className="mb-1"><i className="d-md-none d-inline-block far fa-clock mr-3"></i>Your trial offer expires in</h3>
							<small className="text-muted">Hurry and checkout now before your trial offer expires!</small>
						</div>
					</div>
					<div className="col-auto mt-md-0 mt-3">
					    <div className="d-flex justify-content-md-end justify-content-center" id="countdown">
						    <p className="mr-3 red">{this.state.time.m}<sub className="ml-2">minutes</sub></p>
						    <p className="red">{this.state.time.s}<sub className="ml-2">seconds</sub></p>
						</div>
					</div>
				</div>
			</div>
		);
        
    }
}

Timer.contextType = AppContext;
export default Timer;



// WEBPACK FOOTER //
// ./src/components/general/include/Timer.js